import type { ReactNode } from 'react';
import { GrainOverlay } from '@/components/brand/grain-overlay';

/** The stage gradient (NEWS-01): navy 165deg + blue radials. */
const STAGE_BACKGROUND =
  'radial-gradient(60% 70% at 85% 15%, rgba(21,93,252,0.55), rgba(21,93,252,0) 70%), radial-gradient(50% 60% at 5% 100%, rgba(21,93,252,0.28), rgba(21,93,252,0) 70%), linear-gradient(165deg, #0B348C 0%, #15191E 82%)';

/**
 * The brand stage behind the edition: gradient, grain and whatever sits
 * between them (the torus); the content stacks above.
 */
export function Stage({
  backdrop,
  children,
}: {
  /** Drawn over the gradient and under the grain (the torus). */
  backdrop?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="relative isolate flex h-full flex-col overflow-hidden text-white">
      <div
        aria-hidden="true"
        className="absolute inset-0 -z-30"
        style={{ backgroundImage: STAGE_BACKGROUND }}
      />
      {backdrop}
      <GrainOverlay className="-z-10" />
      {children}
    </div>
  );
}
